/**
 * Opens one TIG short in the player modal, from anywhere on the storefront.
 *
 * The tiles and the player both live in cross-origin TIG iframes, so a short
 * cannot be opened by URL or by clicking into the carousel from the parent
 * page. What works is a customwapi embed for the single short, whose ready
 * callback hands back an api with open().
 *
 * Two waits are unavoidable:
 *
 *   initTigCreatorEmbed arrives with the TIG app embed, which is async, so it
 *   may not exist yet when a page-load caller asks for a short.
 *
 *   customReadyCallback fires at init, but the contents list it validates
 *   against loads after that, so open() throws for a few hundred ms.
 *
 * Used by tig-short-favorite-list.js (a card click on My Page) and by
 * tig-short-favorite-login-redirect.js (reopening after a login round trip).
 */
(function () {
  if (window.TigShortPlayer) return;

  // 10s: the embed script is third party and a cold CDN hit is slow.
  var EMBED_ATTEMPTS = 100;
  var OPEN_ATTEMPTS = 50;
  var RETRY_MS = 100;

  // One api per short, because each customwapi embed is built for a single id.
  var players = {};

  function whenEmbedReady(callback, attempt) {
    attempt = attempt || 0;
    if (typeof initTigCreatorEmbed === 'function') return callback();
    if (attempt >= EMBED_ATTEMPTS) {
      console.warn('[tig-short-player] tig-creator-embed did not load');
      return;
    }
    setTimeout(function () {
      whenEmbedReady(callback, attempt + 1);
    }, RETRY_MS);
  }

  function openWhenReady(api, id, attempt) {
    attempt = attempt || 0;
    try {
      api.open(id);
    } catch (error) {
      if (attempt >= OPEN_ATTEMPTS) {
        console.warn('[tig-short-player] short did not become playable:', id, error);
        return;
      }
      setTimeout(function () {
        openWhenReady(api, id, attempt + 1);
      }, RETRY_MS);
    }
  }

  /**
   * @param {string} id        TIG content identifier.
   * @param {string} [taTag]   TIG analytics tag. Pass the one the calling
   *                           surface is tracked under; TIG only counts tags
   *                           it knows, so this is not a free-form label.
   */
  function open(id, taTag) {
    id = String(id);
    whenEmbedReady(function () {
      if (players[id]) return openWhenReady(players[id], id);

      // contentsId must be a single id: an array leaves the contents list
      // undefined and open() throws.
      initTigCreatorEmbed({
        type: 'customwapi',
        contentsId: id,
        urlParam: { ta_tag: taTag || 'collection_tile_short' },
        customReadyCallback: function (api) {
          players[id] = api;
          openWhenReady(api, id);
        },
      });
    });
  }

  window.TigShortPlayer = { open: open };
})();
